export default `
	amount_unused
    amount_used
    credit_bundle_available_for

    timeslot_kind {
        guid
    }
`;